import { BaseTabelaPDF, helperPDF, } from '@monorepo-web/pdf-generator';
import { getLayouts } from './layout';
export default function TabelaRetornosNominaisPDF(props) {
    const { titulo = 'Retornos Nominais da Carteira x Benchmarks', layout = 'default', dadosMesAMesAgrupados, theme, rows } = props;
    const columns = getLayouts(dadosMesAMesAgrupados, theme)[layout];
    const body = helperPDF.gerarBodyComCor(rows, columns.slice(1), theme, 10, columns[0].rowSpan, 'ano', columns[0].bgColor);
    return BaseTabelaPDF(Object.assign(Object.assign({}, props), { titulo,
        columns, tableConfig: {
            body,
            halign: 'center',
            columnStyleIndex: 1,
            minCellHeight: theme.minCellHeightPDF + 1,
        } }));
}
